import { newsFeed } from '@modules/news-feed/newsFeed.js'
import { userPhotoGallery } from '@modules/photoswipe/userPhotoGallery.js'
import { photoSettings } from './photo.js'
import { notifications } from './notifications.js'
import { initVerifyActions } from './verify.js'
import Form from '@utils/Form.js'

initVerifyActions()

const userFeedElement = document.querySelector('#user-feed')

if (userFeedElement) {
    const url = userFeedElement.dataset.url
    const expandUrl = userFeedElement.dataset.expandUrl
    const expandUserUrl = userFeedElement.dataset.expandUserUrl
    const username = userFeedElement.dataset.username

    newsFeed({
        feed: '#user-feed',
        maxAutoPages: 3,
        autoLoad: true,
        data: {
            user: username,
        },
        url,
        expandUrl,
        expandUserUrl,
    })
}

const formElement = document.querySelector('.user-settings .js-form')
if (formElement) {
    Form.find(formElement)
        .init()
        .then(() => {
            window.location.href = '/user/settings'
        })
}

document.querySelectorAll('.photo-grid a.user-photo').forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault()

        userPhotoGallery({
            user: el.dataset.username,
            first: el.dataset.id,
        })
    })
})

photoSettings()

/**
 * User profile settings
 */
const removeArtworkBtn = document.querySelector('.user-settings .remove-artwork')
if (removeArtworkBtn) {
    removeArtworkBtn.addEventListener('click', function () {
        const input = document.createElement('input')
        input.setAttribute('name', 'artworkRemoved')
        input.setAttribute('value', 'true')
        input.setAttribute('type', 'hidden')
        this.insertAdjacentElement('afterend', input)
        const defaultImage = '/content/img/user/anonymous-large.jpg'
        document.getElementById('user-artwork').setAttribute('src', defaultImage)
        this.remove()
    })
}

const artworkInput = document.getElementById('artwork')
if (artworkInput) {
    artworkInput.addEventListener('change', updateArtwork)
}

function updateArtwork() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const input = this
    if (this.files && this.files[0]) {
        const reader = new FileReader()
        const container = document.getElementById('artwork-container')
        container.classList.add('loading')
        const wrapper = container.querySelector('.wrapper')
        const image = container.querySelector('#user-artwork')
        const size = wrapper.offsetWidth

        reader.onload = function (e) {
            const newImage = new Image()
            newImage.onload = function () {
                container.classList.remove('loading')
                const height = this.height
                const width = this.width

                let newWidth = size
                let newHeight = size
                if (width > height) {
                    newHeight = size
                    newWidth = Math.round(width * (newHeight / height))
                } else if (height > width) {
                    newWidth = size
                    newHeight = Math.round(height * (newWidth / width))
                }

                image.style.width = newWidth + 'px'
                image.style.height = newHeight + 'px'
                image.style.marginLeft = -((newWidth - size) / 2) + 'px'
                image.style.marginTop = -((newHeight - size) / 2) + 'px'
                image.style.maxWidth = 'none'
                image.style.maxHeight = 'none'
                image.setAttribute('src', this.src)
            }
            newImage.onerror = function () {
                container.classList.remove('loading')
                alert('Something went wrong')
                input.value = ''
            }
            newImage.src = e.target.result
        }
        reader.readAsDataURL(this.files[0])
    }
}

notifications()
